<template>
  <b-card no-body>
    <template v-slot:header>
      <b-row class="align-items-center">
        <b-col>
          <font-awesome-icon :icon="icon" :size="iconSize" class="align-middle text-muted" :class="{'mr-2': $dir.ltr, 'ml-2': $dir.rtl}"/>
          {{ title }}
        </b-col>

        <b-col md="auto">
          <b-input-group :prepend="$t('shared.create')" size="sm">
            <b-form-select v-model="widgetType" :options="widgetTypes"/>

            <b-input-group-append>
              <b-btn variant="success" @click="add" :class="{'rounded-right': $dir.ltr, 'rounded-left': $dir.rtl}">
                <font-awesome-icon icon="plus" class="align-middle"/>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </template>

    <items ref="widgetItems" v-model="widgets" @remove="remove"/>
  </b-card>
</template>

<script>
import Items from './Items'

export default {
  name: 'WidgetsEditor',
  components: {
    Items
  },
  props: {
    value: Array,
    title: String,
    icon: { type: String | Object, default: 'th-large' },
    iconSize: String
  },
  data () {
    return {
      widgetType: null,
      model: {
        widgetTypes: [
          {
            id: null,
            type: 'Component',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            component: null,
            componentData: null
          },
          {
            id: null,
            type: 'Header',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            description: null,
            image: null,
            component: null,
            componentData: null
          },
          {
            id: null,
            type: 'Items',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            items: []
          },
          {
            id: null,
            type: 'Nav',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            items: []
          },
          {
            id: null,
            type: 'Posts',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            featuredOnly: false,
            categoryId: null,
            count: 16
          },
          {
            id: null,
            type: 'Text',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            body: null,
            image: null
          },
          {
            id: null,
            type: 'Slider',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            items: []
          },
          {
            id: null,
            type: 'Products',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            featuredOnly: false,
            availableOnly: true,
            sellerIds: [],
            brandIds: [],
            typeId: null,
            sizeIds: null,
            colorIds: null,
            groupIds: [],
            categoryIds: [],
            minPrice: null,
            maxPrice: null,
            keyword: null,
            tags: null,
            count: 16,
            sort: 0
          },
          {
            id: null,
            type: 'Brands',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            count: 16,
            tags: []
          },
          {
            id: null,
            type: 'ProductGroups',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            count: 16
          },
          {
            id: null,
            type: 'ProductCategories',
            title: null,
            subtitle: null,
            url: null,
            availability: 'everyone',
            viewData: null,
            view: null,
            groupId: null
          }
        ]
      }
    }
  },
  computed: {
    widgetTypes () {
      return [{ value: null, text: this.$t('widgetAreas.widgetType')}].concat(this.model.widgetTypes.map(w => {
        return {
          value: w.type,
          text: this.$t('widgetAreas.typeWidget', {type: this.$t('widgetAreas.types.' + w.type)})
        }
      }))
    },
    widgets: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    add () {
      if (this.widgetType) {
        const widget = Object.assign({}, this.model.widgetTypes.find(i => i.type === this.widgetType))
        let newWidget = Object.assign(widget, {
          id: -String(Math.floor(Math.random() * 99999999))
        })
        this.widgets.push(newWidget)
      }
    },
    remove (item) {
      this.widgets = this.widgets.filter(i => i.id !== item.id)
    },
    validateAll () {
      return this.$refs.widgetItems.validateAll()
    }
  }
}
</script>